import React from 'react'
import LanguageSelect from "../LanguageSelect";

import classes from './styles.module.css'

export default function Footer({lang, onChangeLanguage}) {

    let brand = [
        {bgColor: ''},
        {copyText: ''}
    ];

    switch (process.env.BRAND) {
        case "wl":
            brand.bgColor = "#273246"
            brand.copyText = "GNU General Public License, GPL"
            break;
        case "unlimco":
            brand.bgColor = "#273246"
            brand.copyText = "«Unlimco Group» LLC ©"
            break;
        case "eclear":
            brand.bgColor = "#152A44"
            brand.copyText = "«E-Clear Group» LLC ©"
            break;
        default:
            brand.bgColor = "#273246";
            brand.copyText = "GNU General Public License, GPL"
    }

    return (
        <footer className={classes.Footer} style={{backgroundColor: brand.bgColor}}>
            <div className={classes.Container}>
                <LanguageSelect lang={lang} onChangeLanguage={onChangeLanguage}/>
                <span className={classes.Copy}>{brand.copyText}</span>
            </div>
        </footer>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Footer/index.js